import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

function Register() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();

    // Redirect if already authenticated
    useEffect(() => {
        if (isAuthenticated) {
            navigate('/');
        }
    }, [isAuthenticated, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const { data } = await axios.post('https://backend.ithyaraa.com/api/brand/register', { name, email, password });

            if (data.success) {
                // Registration successful - redirect to login
                alert('Brand account created successfully! Please login with your credentials.');
                navigate('/login');
            } else {
                setError(data.message || 'Registration failed');
            }
        } catch (err) {
            const errorMessage = err.response?.data?.message || err.message || 'Registration failed';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[var(--bg)] text-[var(--text)] p-4">
            <form onSubmit={handleSubmit} className="w-[380px] card flex flex-col gap-3 p-6">
                <h2 className="lux-heading m-0 text-2xl">Create Brand Account</h2>
                {error ? (
                    <div className="text-white bg-red-500 px-2 py-2 rounded-md">{error}</div>
                ) : null}
                <label className="flex flex-col gap-1.5">
                    <span>Name</span>
                    <input className="px-3 py-3 rounded-lg border border-[var(--border)] bg-[var(--surface)] text-[var(--text)]" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" required />
                </label>
                <label className="flex flex-col gap-1.5">
                    <span>Email</span>
                    <input type="email" className="px-3 py-3 rounded-lg border border-[var(--border)] bg-[var(--surface)] text-[var(--text)]" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" required />
                </label>
                <label className="flex flex-col gap-1.5">
                    <span>Password</span>
                    <input type="password" className="px-3 py-3 rounded-lg border border-[var(--border)] bg-[var(--surface)] text-[var(--text)]" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
                </label>
                <button disabled={loading} className="btn-primary py-3 rounded-lg cursor-pointer disabled:opacity-70">{loading ? 'Creating…' : 'Create account'}</button>
                <div className="text-sm text-[var(--muted)]">Already have an account? <a href="/login" className="underline">Sign in</a></div>
            </form>
        </div>
    );
}

export default Register;


